"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const mapStateToProps = state => {
  return {
    queryParams: state.ssoauth
  };
};
const apiUrl = process.env.REACT_APP_API;
const redirectUri = process.env.REACT_APP_SSO_REDIRECT_URI;
const oAuthEndpoint = process.env.REACT_APP_OAUTH_ENDPOINT;
const SSOAuth = () => {
  const logo_big = `/logo_big.svg`;
  const [view, setView] = (0, _react.useState)("");
  const [error, setError] = (0, _react.useState)(false);
  const storeCode = (code_challenge, auth_code) => {
    const body = {
      CodeChallenge: code_challenge,
      AuthorizationCode: auth_code
    };
    fetch(apiUrl + "tokenauthcodes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then(response => {
      console.log(response);
      if (response.ok) {
        localStorage.removeItem("code_challenge");
        console.log("Code stored successfully");
      } else {
        console.error("Failed to store code");
      }
    }).catch(error => {
      console.error("Network error:", error);
    });
  };
  (0, _react.useEffect)(() => {
    const getQueryParams = () => {
      const queryParameters = new URLSearchParams(window.location.search);
      const params = {};
      for (const [key, value] of queryParameters.entries()) {
        params[key] = value;
      }
      return params;
    };
    const queryParameters = getQueryParams();
    function generateRandomString(length) {
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
    const randomState = generateRandomString(32);
    const redirectUrl = `${oAuthEndpoint}?` + `client_id=${queryParameters.client_id}` + `&code_challenge=${queryParameters.code_challenge}` + `&code_challenge_method=S256` + `&nonce=${queryParameters.nonce}` + `&redirect_uri=${redirectUri}/ssoauth` + `&response_type=code` + `&scope=openid+email+profile` + `&state=${randomState}`;
    console.log(redirectUrl);
    function simulateClick() {
      const link = document.createElement("a");
      link.href = redirectUrl;
      link.target = "_self";
      const clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
      });
      link.dispatchEvent(clickEvent);
    }
    if (queryParameters.error) {
      if (queryParameters.error_description) {
        setError(queryParameters.error_description);
      } else {
        setError("");
      }
    } else if (!queryParameters.state) {
      setView("first_step");
      localStorage.setItem("randomState", randomState);
      localStorage.setItem("code_challenge", queryParameters.code_challenge);
      simulateClick();
    } else {
      const storedParams = localStorage.getItem("randomState");
      if (storedParams && storedParams === queryParameters.state) {
        setView("second_step");
        localStorage.removeItem("randomState");
        const code_challenge = localStorage.getItem("code_challenge");
        storeCode(code_challenge, queryParameters.code);
        console.log("queryParameters.state:", queryParameters.state);
      } else {
        console.log("queryParameters.state:", queryParameters.state);
        setView("error");
        setError("");
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%"
    },
    className: "bg-sso"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1rem"
    },
    className: "card rounded shadow p-5"
  }, !error && view === "first_step" && /*#__PURE__*/_react.default.createElement(FirstStep, {
    logo: logo_big
  }), !error && view === "second_step" && /*#__PURE__*/_react.default.createElement(SecondStep, {
    logo: logo_big
  }), error && /*#__PURE__*/_react.default.createElement(ErrorStep, {
    logo: logo_big,
    errorDescription: error
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "/imprint",
    target: "_blank",
    rel: "noreferrer",
    style: {
      position: "absolute",
      bottom: 0,
      margin: "0 auto",
      left: 0,
      right: 0,
      color: "white",
      width: "fit-content"
    }
  }, "Imprint - Privacy Policy - Legal"));
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(SSOAuth);
const FirstStep = ({
  logo
}) => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "logo"
  }), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      margin: 0
    }
  }, "You are now being redirected to the login page."), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      margin: 0
    }
  }, "Please continue the login process there."));
};
const SecondStep = ({
  logo
}) => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "logo"
  }), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      margin: 0
    }
  }, "Authentication successful!"), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      margin: 0
    }
  }, "You are all set to dive back into the application."));
};
const ID_FIAS_USER_EXISTS_ERROR = "The sign-in with your identity provider failed, because a user with the same credentials allready exists";
const ID_FIAS_QUOTA_EXCEEDED_ERROR = "The sign-in with your identity provider failed, because currently there are no more licences available";
const ID_FIAS_TOKEN_RECEIVE_FAILED_ERROR = "The sign-in with your identity provider failed, bacause an error occured during the authorization process:";
const ID_FIAS_GENERAL_ERROR = "The sign-in with your identity provider failed:";
const ErrorStep = ({
  logo,
  errorDescription
}) => {
  const errorMessage = (0, _react.useMemo)(() => {
    let error = "";
    console.error("FIASAuthenticationResponse error received: " + errorDescription);
    if (errorDescription.includes("User exists")) {
      error = ID_FIAS_USER_EXISTS_ERROR;
    } else if (errorDescription.includes("License quota exceeded")) {
      error = ID_FIAS_QUOTA_EXCEEDED_ERROR;
    } else {
      error = ID_FIAS_GENERAL_ERROR + " " + errorDescription;
    }
    return error;
  }, [errorDescription]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "logo"
  }), errorMessage && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: "red"
    }
  }, errorMessage));
};
module.exports = exports.default;